import { FieldHelpProps, FormContextType, RJSFSchema, StrictRJSFSchema, helpId } from '@snups/rjsf-utils';

/** The `FieldHelpTemplate` component renders any help desired for a field
 *
 * @param props - The `FieldHelpProps` to be rendered
 */
export default function FieldHelpTemplate<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>(props: FieldHelpProps<T, S, F>) {
  const { idSchema, help } = props;
  if (help) {
    const id = helpId<T>(idSchema);
    return <small id={id}>{help}</small>;
  }
  return null;
}
